"use client";

import { useSelection } from "@trydig/centra/client";
import { formatCartItems } from "@trydig/centra/formatting";

export type CartItem = NonNullable<ReturnType<typeof formatCartItems>>[number];

export const useCart = () => {
	return useSelection({
		select: (data) => {
			// Cart thumbs render at ~117x156 — `standard` (600x800) is plenty for
			// retina and saves a lot vs `full` (972x972 square, also wrong aspect).
			const items = formatCartItems(data, "standard");
			const count = data.selection?.items?.reduce((n, item) => n + (item.quantity ?? 0), 0) ?? 0;

			return {
				items,
				count,
				currency: data.selection?.currency,
				subtotal: data.selection?.totals?.itemsTotalPrice,
				subtotalAsNumber: data.selection?.totals?.itemsTotalPriceAsNumber,
				shippingPrice: data.selection?.totals?.shippingPrice,
				shippingPriceAsNumber: data.selection?.totals?.shippingPriceAsNumber,
				total: data.selection?.totals?.grandTotalPrice,
				vat: data.selection?.totals?.grandTotalPriceTax,
				hasItems: (data.selection?.items?.length ?? 0) > 0,
				vouchers: data?.selection?.discounts?.vouchers,
			};
		},
	});
};
